import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Table, Button, Form, ButtonGroup, DropdownButton, Dropdown, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RouteComponentProps, Link } from "react-router-dom";
import { STORE_KASSES } from "../../constants";
import { KassesStore } from "../../stores";
import { formatDate } from "../../common/Formatting";

interface IProps {
    history: any,
    [STORE_KASSES]: KassesStore
}

interface IState {
    deviceId: string
}


type Props = IProps & RouteComponentProps<{ deviceId: string }>;

@inject(STORE_KASSES)
@observer
export class KassaDetailsPage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const deviceId = this.props.match.params.deviceId;
        this.state = {
            deviceId: deviceId
        };
    }

    private kassesStore = (this.props as any)[STORE_KASSES] as KassesStore;


    componentDidMount() {
        const deviceId = this.props.match.params.deviceId;
        this.setState({
            deviceId: deviceId
        }, () => {
            this.kassesStore.loadKassaDetails(this.state.deviceId);
        });
    }
    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        if (prevProps.match.params.deviceId !== this.props.match.params.deviceId) {
            const deviceId = this.props.match.params.deviceId;
            this.setState({
                deviceId: deviceId
            }, () => {
                this.kassesStore.loadKassaDetails(this.state.deviceId);
            });

        }

    }
    private closeShift = () => {
        if (window.confirm("Вы хотите закрыть смену. Продолжить?")) {
            this.kassesStore.closeShift(this.state.deviceId);
        }
    }
    render() {
        return <div>
            <br />
            <Row>
                <Col sm={4}>
                    <Card className="text-center">
                        <Card.Header>Информация о кассе</Card.Header>
                        <Card.Body>
                            {this.kassesStore.kassaDetails != undefined ? <Table size="sm">
                                <tr>
                                    <th className="text-left">Версия прошивки</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.firmwareVersion}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Версия ПО ККТ</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.appVersion}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Версия загрузчика</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.boolVersion}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Версия движка шаблонов</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.scriptsVersion}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Наименовние загруженных шаблонов</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.scriptsName}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Код модели</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.modelName}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Ширина чековой ленты в символах для шрифта по умолчанию</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.receiptLineLength}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Ширина чековой ленты в пикселях</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.receiptLineLengthPix}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Заводской номер ККТ</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.serial}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Версия ФФД</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.ffdVersion}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Версия ФФД ФН</th>
                                    <td>{this.kassesStore.kassaDetails.deviceInfo.fnFfdVersion}</td>
                                </tr>
                            </Table> : []}
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={4}>
                    <Card className="text-center">
                        <Card.Header>Состояние кассы</Card.Header>
                        <Card.Body>
                            {this.kassesStore.kassaDetails != undefined ? <Table size="sm">
                                <tr>
                                    <th className="text-left">Текущие дата и время</th>
                                    <td>{formatDate(this.kassesStore.kassaDetails.deviceStatus.currentDateTime)}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Состояние смены</th>
                                    <td>{this.kassesStore.kassaDetails.deviceStatus.shift}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">ККТ заблокирована</th>
                                    <td>{this.kassesStore.kassaDetails.deviceStatus.blocked ? 'Да' : 'Нет'}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Состояние крышки</th>
                                    <td>{this.kassesStore.kassaDetails.deviceStatus.coverOpened ? 'Открыта' : 'Закрыта'}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Наличие бумаги</th>
                                    <td>{this.kassesStore.kassaDetails.deviceStatus.paperPresent ? 'Да' : 'Нет'}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">ККТ фискализирована</th>
                                    <td>{this.kassesStore.kassaDetails.deviceStatus.fiscal ? 'Да' : 'Нет'}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">ФН фискализирован</th>
                                    <td>{this.kassesStore.kassaDetails.deviceStatus.fnFiscal ? 'Да' : 'Нет'}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">ФН обнаружен</th>
                                    <td>{this.kassesStore.kassaDetails.deviceStatus.fnPresent ? 'Да' : 'Нет'}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Денежный ящик открыт</th>
                                    <td>{this.kassesStore.kassaDetails.deviceStatus.cashDrawerOpened ? 'Да' : 'Нет'}</td>
                                </tr>

                            </Table> : []}
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={4}>
                    <Card className="text-center">
                        <Card.Header>Состояние смены</Card.Header>
                        <Card.Body>
                            {this.kassesStore.kassaDetails != undefined ? <Table size="sm">
                                <tr>
                                    <th className="text-left">Состояние</th>
                                    <td>
                                        {this.kassesStore.kassaDetails.shiftStatus.state}
                                        {this.kassesStore.kassaDetails.shiftStatus.state !== "closed" ? <Button size="sm"
                                            className="pull-right" title="Закрыть смену" variant="danger"
                                            onClick={this.closeShift}>
                                            <FontAwesomeIcon icon="times" />
                                        </Button> : []}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="text-left">Номер смены</th>
                                    <td>{this.kassesStore.kassaDetails.shiftStatus.number}</td>
                                </tr>
                                <tr>
                                    <th className="text-left">Истекает</th>
                                    <td>{formatDate(this.kassesStore.kassaDetails.shiftStatus.expiredAt)}</td>
                                </tr>
                            </Table> : []}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div >
    }

}